<template>
  <div id="app">
    <NavBar/>
    <router-view/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

export default {
    components: {
      NavBar
  }
}

</script>

<style>

body {
  background-color: #FBF0E5;
  padding-bottom: 4em;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.blurb-content {
  width: 85%;
  margin: auto;
  padding-top: 1em;
  font-family: 'Baloo 2', cursive;
  font-size: 1.1em;
  color: #6F4E37;
}

.blurb-title {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 2em;
  color: #6F4E37;
  text-align: left;
  padding-top: .5em;
  padding-left: 10%;
}

.blurb-decoration-bar {
  width: 80%;
  border-top: solid;
  border-color: #DDCDBF;
  margin: auto;
}
</style>
